export var UNDERSTANDING_SECTION = "UNDERSTANDING_SECTION";
export var UNDERSTANDING_ERROR = "UNDERSTANDING_ERROR";
export var UNDERSTANDING_HIDE_ERROR = "UNDERSTANDING_HIDE_ERROR";
